import ReservationCardInformation from './ReservationCardInformation'
import {FACILITY_RESERVATION_CONFIRMED_DATE} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'

export default class ReservationsOfWaitingConfirmation {
    facilityReserveConfirmLimit: Nullable<FACILITY_RESERVATION_CONFIRMED_DATE>
    reservationCardInformations: ReservationCardInformation[]

    constructor(
        facilityReserveConfirmLimit: Nullable<FACILITY_RESERVATION_CONFIRMED_DATE>,
        reservationCardInformations: ReservationCardInformation[],
    ) {
        this.facilityReserveConfirmLimit = facilityReserveConfirmLimit
        this.reservationCardInformations = reservationCardInformations
    }

    static from(json: any): ReservationsOfWaitingConfirmation {
        return new ReservationsOfWaitingConfirmation(
            !(json.facilityReserveConfirmLimit) ? null :
                FACILITY_RESERVATION_CONFIRMED_DATE.codeToEnumConstants(json.facilityReserveConfirmLimit),
            json.reservationCardInformations.map((info: any) => ReservationCardInformation.from(info)),
        )
    }
}
